"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.officeUrl = exports.getStructuredData = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _string = require("@raywhite/helpers-utils/lib/helpers/string");
var _sanitization = require("@raywhite/helpers-utils/lib/helpers/sanitization");
var _structuredData = require("@raywhite/helpers-utils/lib/helpers/structuredData");
var _address = require("./address");
var officeUrl = function (_ref) {
  var _context;
  var {
    fullName,
    id,
    organisationId
  } = _ref;
  var isPrimary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return isPrimary ? '/about' : (0, _concat.default)(_context = "/about/".concat((0, _string.toSlug)(fullName), "/")).call(_context, id || organisationId);
};
exports.officeUrl = officeUrl;
var getStructuredData = function (data, isPrimary, baseUrl) {
  var _context2;
  var {
    imageOverride,
    nameOverride
  } = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var {
    address: {
      country,
      latitude,
      locality,
      longitude,
      postCode,
      region,
      state,
      streetAddress
    } = {},
    description,
    email,
    facebook,
    fax,
    fullName,
    googlePlus,
    imageExterior,
    imageReception,
    imageStaff,
    imageTeam,
    instagram,
    linkedin,
    name,
    phone,
    pinterest,
    twitter,
    youtube
  } = data;
  var image = imageOverride || imageStaff || imageExterior || imageReception || imageTeam;
  var scaledImage = image && ((0, _includes.default)(image).call(image, '?') ? image : "".concat(image, "?maxwidth=1280"));
  return (0, _structuredData.realEstateAgent)({
    name: nameOverride || fullName,
    description: (0, _sanitization.plainText)(description),
    url: baseUrl && (0, _concat.default)(_context2 = "".concat(baseUrl)).call(_context2, officeUrl(data, isPrimary)),
    address: (0, _structuredData.postalAddress)({
      streetAddress,
      addressLocality: locality,
      addressRegion: region || state,
      postalCode: postCode,
      addressCountry: (0, _address.getCountryFromCode)(country) || country
    }),
    geo: latitude && longitude ? (0, _structuredData.geoCoordinates)({
      latitude,
      longitude
    }) : undefined,
    faxNumber: fax,
    telephone: phone,
    email,
    brand: (0, _structuredData.brand)({
      name: fullName.replace(name, '').replace(/\s+$/, '')
    }),
    image: scaledImage,
    sameAs: [facebook, twitter, googlePlus, youtube, linkedin, pinterest, instagram]
  });
};
exports.getStructuredData = getStructuredData;